import { observer } from 'mobx-react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { ControlIcons } from 'owa-control-icons';
import setIsDarkMode from 'owa-mail-compose-store/lib/actions/setIsDarkMode';
import ComposeViewState from 'owa-mail-compose-store/lib/store/schema/ComposeViewState';
import * as React from 'react';

const styles = require('./ComposeDarkModeToggle.scss');

export interface ComposeDarkModeToggleProps {
    viewState: ComposeViewState;
}

interface ComposeDarkModeToggleState {
    isTurnOnLights: boolean;
}

@observer
export class ComposeDarkModeToggle extends React.Component<
    ComposeDarkModeToggleProps,
    ComposeDarkModeToggleState
> {
    constructor(props: ComposeDarkModeToggleProps) {
        super(props);
        this.state = {
            isTurnOnLights: this.props.viewState.isDarkMode,
        };
    }

    private onToggleChange = (event: React.MouseEvent<HTMLElement>, checked?: boolean) => {
        setIsDarkMode(this.props.viewState, !this.state.isTurnOnLights);
        this.setState({
            isTurnOnLights: !this.state.isTurnOnLights,
        });
    };

    render() {
        const { isTurnOnLights } = this.state;
        return (
            <div role="button" className={styles.darkModeToggle} onClick={this.onToggleChange}>
                <Icon
                    className={styles.icon}
                    iconName={isTurnOnLights ? ControlIcons.Sunny : ControlIcons.ClearNight}
                />
                <div className={styles.label}>
                    {isTurnOnLights ? 'Turn on the lights' : 'Turn off the lights'}
                </div>
            </div>
        );
    }
}

export default ComposeDarkModeToggle;
